import * as THREE from 'three'
export default {
    branchLength: 50,
    branchStartingThickness: 10,
    branchColor: new THREE.Color("rgb(47, 22, 8)"),
    stemToStemRatio: 0.8,
    stemToBranchRatio: 0.9,
    angle: 60,
    axisRotation: 192,
    depth: 3,
    branches: 6,
    roots: false,
    leafs: false,
    enableRandomAxisRotation: false,
    animate: false
}